import React from "react";
import {
  Container,
  Card,
  CardHeader,
  ListGroup,
  ListGroupItem,
  Row,
  Col
} from "shards-react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { FcAcceptDatabase } from "react-icons/fc";
import { TiEdit } from "react-icons/ti";
import ProjectSupplierDataService from "../../services/supplier.service";
import moment from "moment";
const SPAIN = process.env.REACT_APP_MARKET === "SPAIN";
const SAUDI = process.env.REACT_APP_MARKET === "SAUDI";

class ProjectStructureDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projectSupplierDetails:"",
    };    
    
  }


  componentDidMount() {
    // this.retrieveProjectDetails();
     if(this.props.projectSupplierId)
     this.retrieveProjectSupplierDetails();
   }

  componentDidUpdate(prevProps) {
    if (this.props.projectSupplierId != prevProps.projectSupplierId)
      this.retrieveProjectSupplierDetails();
  }

  retrieveProjectSupplierDetails(){
		ProjectSupplierDataService.get(this.props.projectSupplierId).then((response) => {
			var projectSupplierDetails = response.data.data;
      var resultArr = [];
      resultArr.push(projectSupplierDetails)

      this.setState({
        projectSupplierDetails: resultArr
			});
  	});
	}

  notify(type, message) {
		toast(message, {
			position: "top-right",
			autoClose: 5000,
			hideProgressBar: true,
			closeOnClick: true,
			type: type,
		});
	}

  render() {
    
    const {
        projectSupplierDetails
    } = this.state;

    const {
      projectId, 
    } = this.props;

    return (
    <div>
      <Card small className="mb-4">
        <CardHeader className="border-bottom">
          <h6 className="m-0">
            Supplier Details
            <Link className="btn btn-primary ml-4" to={"/project/"+projectId+"/supplier"}><FcAcceptDatabase /> View All</Link>
            {projectSupplierDetails && projectSupplierDetails.map(function (item,index){
              return( 
                    <Link className="btn btn-primary ml-4 float-right" to={"/project/"+projectId+"/supplier/"+item.id+"/edit"}><TiEdit /> Edit Supplier</Link>
                  )
                }
              )
            }
          </h6>
        </CardHeader>
        <ListGroup flush>
          <ListGroupItem className="">
            <Row form>
              <Col md="12" className="form-group">
            {projectSupplierDetails && projectSupplierDetails.map(function (item,index){
              return( 
                     <>
                      <Row className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierName">
                          {SPAIN ? 'Hospital Name': 'Supplier Name'}</label></Col>
                        <Col className="form-field" md="8">{item.supplierName}</Col>
                      </Row>
  
                      <Row className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierCode">{SPAIN ? 'Hospital Code': 'Supplier Code'}</label></Col>
                        <Col className="form-field" md="8">{item.supplierCode}</Col>
                      </Row>

                      {SAUDI && (
                      <Row className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="dsCode">DS Code</label></Col>
                        <Col className="form-field" md="8">{item.dsCode}</Col>
                      </Row>
                      )}

                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierERP">{SPAIN ? 'Hospital ERP': 'Supplier ERP'}</label></Col>
                        <Col className="form-field" md="8">{item.supplierERP}</Col>
                      </Row>

                      {/* <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierERP">Supplier ERP</label></Col>
                        <Col className="form-field" md="8">{item.supplierERP}</Col>
                      </Row> */}
                      
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierAddress">{SPAIN ? 'Hospital Address': 'Supplier Address'}</label></Col>
                        <Col className="form-field" md="8">{item.supplierAddress}</Col>
                      </Row>

                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierCity">{SPAIN ? 'Hospital City': 'Supplier City'}</label></Col>
                        <Col className="form-field" md="8">{item.supplierCity}</Col>
                      </Row>

                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierState">{SPAIN ? 'Hospital State': 'Supplier State'}</label></Col>
                        <Col className="form-field" md="8">{item.supplierState}</Col>
                      </Row>

                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierZone">{SPAIN ? 'Hospital Zone': 'Supplier Zone'}</label></Col>
                        <Col className="form-field" md="8">{item.supplierZone}</Col>
                      </Row>

                      {(SPAIN || SAUDI) && (
                        <Row  className="form-group-row">
                          <Col className="form-label" md="4"><label htmlFor="supplierMergeMultipleFiles">Allow Merging Multiple Files</label></Col>
                          <Col className="form-field" md="8">{item.supplierMergeMultipleFiles ? 'TRUE' : 'FALSE'}</Col>
                        </Row>
                      )}

                      {SPAIN && (
                        <Row  className="form-group-row">
                          <Col className="form-label" md="4"><label htmlFor="supplierMultipleSheets">Allow Multiple Sheets</label></Col>
                          <Col className="form-field" md="8">{item.supplierMultipleSheets}</Col>
                        </Row>
                      )}

                      {/* <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierFileLocation">Supplier File Location</label></Col>
                        <Col className="form-field" md="8"> {(item.supplierFileLocation == true) ? 'Yes' : 'No'}</Col>
                      </Row>

                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="feFirstName">File Location Configuration</label></Col>
                        <Col className="form-field" md="8">
                            <div>
                              <b>Server Path : </b> {item.serverPath}
                            </div>
                            <div>
                              <b>Server Folder Path : </b>{" "}
                              {item.serverFolderPath}
                            </div>
                        </Col>
                      </Row>
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="createdAt">Created Date </label></Col>
                        <Col className="form-field" md="8">{moment(new Date(item.createdAt)).format("DD/MM/yyyy hh:mm:ss A")}</Col>
                      </Row>
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="createdBy">Modified By </label></Col>
                        <Col className="form-field" md="8">{item.modifiedBy && item.modifiedBy.name}</Col>
                      </Row>
                      <Row  className="form-group-row">
                        <Col className="form-button" md="4">
                          <Link className="btn btn-primary ml-4" to={"/project/"+projectId+"/supplier/"+item.id+"/edit"}><TiEdit /> Edit Supplier</Link>
                        </Col>
                    </Row> */}

                      </>
                        )
                      }
                    )
                  }
                </Col>
               </Row>
          </ListGroupItem>
        </ListGroup>
        <ToastContainer />
      </Card>
      
    </div>
    )
  }
}


export default ProjectStructureDetail;
